<template>
  <v-row justify="center">
    <template v-if="inEditMode">
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="display"
            :clearable="clearable"
            :label="label"
            :placeholder="placeholder"
            :readonly="readonly"
            :rules="rules"
            class="px-3"
            v-on="on"
          />
        </template>

        <m-form-account-full-dialog
          :title="titleComputed"
          :dialog.sync="dialog"
          @pick="onPick"
        />
      </v-dialog>
    </template>
    <template v-else>
      <v-text-field
        :value="display"
        :clearable="clearable"
        :label="label"
        :placeholder="placeholder"
        readonly
        :rules="rules"
        class="px-3"
      />
    </template>
  </v-row>
</template>

<script>
    import MFormAccountFullDialog from "@/assets/plugins/mps-form/providers/components/dialog/MFormAccountFullDialog";
    import MFormAccountPicker from "@/assets/plugins/mps-form/providers/MFormAccountPicker";

    /**
     * 사용하는 옵션
     * {items, itemName(optional), itemValue(optional)}
     */
    export default {
        name: "MFormVuetifyAccountPicker",
        components: {MFormAccountFullDialog},
        extends: MFormAccountPicker,
        data() {
            return {
                dialog: false,
            }
        },
        computed: {},
        methods: {
            onPick(pick) {
                this.dialog = false;
                this.model = pick;
            },
        },
    }
</script>